<template>
  <body class="whyInvest-body" id="investorRelations">
    <div class="title">
      <span>Why Invest in Wecobi?</span> <br />Revolutionizing Sustainable
      Retail
    </div>
    <a
      href="mailto:info@wecobi.com?subject=Meeting Inquiry&body=I would like to request a meeting."
      class="button"
      >Request a meeting</a
    >
  </body>
</template>

<script>
export default {
  name: "WhyInvest",
  components: {},
};
</script>

<style scoped>
.whyInvest-body {
  width: 100%;
  height: 424px;
  color: #ffffff;
  background-image: url("../../../assets/company/WhyInvest.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.title {
  font-size: 37px;
  font-weight: 300;
  line-height: center;
  line-height: 1.3;
  text-align: center;
}
span {
  font-weight: 600;
}
.button {
  width: 184px;
  height: 50px;
  border: 2px solid #ffffff;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  text-decoration: none;
}

.button:hover {
  color: #000000;
  border: 2px solid #ffffff;
  background-color: #ffffff;
}

@media (max-width: 744px) {
  .whyInvest-body {
    height: 292px;
  }
  .title {
    font-size: 30px;
  }
}

@media (max-width: 431px) {
  .whyInvest-body {
    height: 256px;
    padding: 0px 30px;
    box-sizing: border-box;
    align-items: flex-start;
  }
  .title {
    font-size: 25px;
    text-align: left;
  }
}
</style>
